import { RecurrenceFormUnit } from '@griply/types';

import { Frequency } from '../lib/rrule';

export const formUnits = Object.values(RecurrenceFormUnit);

export const formUnitToRruleFreqMap: Record<RecurrenceFormUnit, Frequency> = {
  [RecurrenceFormUnit.Days]: Frequency.DAILY,
  [RecurrenceFormUnit.Weeks]: Frequency.WEEKLY,
  [RecurrenceFormUnit.Months]: Frequency.MONTHLY,
  [RecurrenceFormUnit.Years]: Frequency.YEARLY,
};
